(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/coercion'), require('@shraddhar/web/ripple'), require('@shraddhar/web/icon')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/button', ['exports', '@angular/core', '@angular/common', '@angular/cdk/coercion', '@shraddhar/web/ripple', '@shraddhar/web/icon'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.button = {}), global.ng.core, global.ng.common, global.ng.cdk.coercion, global.ng.web.ripple, global.ng.web.icon));
}(this, (function (exports, core, common, coercion, ripple, icon) { 'use strict';

    var MdcButtonLabel = /** @class */ (function () {
        function MdcButtonLabel() {
        }
        MdcButtonLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-button-label, [mdcButtonLabel]',
                        exportAs: 'mdcButtonLabel',
                        host: { 'class': 'mdc-button__label' }
                    },] }
        ];
        return MdcButtonLabel;
    }());
    var MdcButton = /** @class */ (function () {
        function MdcButton(elementRef, _ripple) {
            this.elementRef = elementRef;
            this._ripple = _ripple;
            this._raised = false;
            this._unelevated = false;
            this._outlined = false;
            this._touch = false;
            this._disabled = false;
            this._ripple = new ripple.MdcRipple(this.elementRef);
            this._ripple.init();
        }
        Object.defineProperty(MdcButton.prototype, "raised", {
            get: function () {
                return this._raised;
            },
            set: function (value) {
                this._raised = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcButton.prototype, "unelevated", {
            get: function () {
                return this._unelevated;
            },
            set: function (value) {
                this._unelevated = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcButton.prototype, "outlined", {
            get: function () {
                return this._outlined;
            },
            set: function (value) {
                this._outlined = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcButton.prototype, "touch", {
            get: function () {
                return this._touch;
            },
            set: function (value) {
                this._touch = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcButton.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabled(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcButton.prototype.ngOnInit = function () {
            if (this._icon) {
                this._icon.elementRef.nativeElement.classList.add('mdc-button__icon');
            }
        };
        MdcButton.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcButton.prototype.setDisabled = function (disabled) {
            this._disabled = coercion.coerceBooleanProperty(disabled);
            if (this._disabled) {
                this.getHostElement().setAttribute('disabled', 'true');
                this.getHostElement().setAttribute('aria-disabled', 'true');
            }
            else {
                this.getHostElement().removeAttribute('disabled');
                this.getHostElement().removeAttribute('aria-disabled');
            }
        };
        /** Focuses the button. */
        MdcButton.prototype.focus = function () {
            this.getHostElement().focus();
        };
        MdcButton.prototype.getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcButton.prototype.onClick = function (event) {
            // A disabled button shouldn't apply any actions
            if (this.disabled) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        MdcButton.decorators = [
            { type: core.Component, args: [{
                        exportAs: 'mdcButton',
                        selector: 'button[mdc-button], a[mdc-button]',
                        host: {
                            '[tabIndex]': 'disabled ? -1 : 0',
                            'class': 'mdc-button',
                            '[class.mdc-button--raised]': 'raised',
                            '[class.mdc-button--unelevated]': 'unelevated',
                            '[class.mdc-button--outlined]': 'outlined',
                            '[class.mdc-button--touch]': 'touch',
                            '(click)': 'onClick($event)'
                        },
                        template: "<div class=\"mdc-button__ripple\"></div>\r\n<mdc-button-label *ngIf=\"label\">{{label}}</mdc-button-label>\r\n<div class=\"mdc-button__touch\" *ngIf=\"touch\"></div>\r\n<ng-content></ng-content>",
                        providers: [ripple.MdcRipple],
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcButton.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: ripple.MdcRipple }
        ]; };
        MdcButton.propDecorators = {
            raised: [{ type: core.Input }],
            unelevated: [{ type: core.Input }],
            outlined: [{ type: core.Input }],
            touch: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            _icon: [{ type: core.ContentChild, args: [icon.MdcIcon, { static: true },] }],
            label: [{ type: core.Input }]
        };
        return MdcButton;
    }());

    var MdcButtonModule = /** @class */ (function () {
        function MdcButtonModule() {
        }
        MdcButtonModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                        ],
                        exports: [
                            MdcButton,
                            MdcButtonLabel,
                        ],
                        declarations: [MdcButton, MdcButtonLabel]
                    },] }
        ];
        return MdcButtonModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcButton = MdcButton;
    exports.MdcButtonLabel = MdcButtonLabel;
    exports.MdcButtonModule = MdcButtonModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-button.umd.js.map
